export const DEBUG_BEAR = {
  CDN_URL: 'https://cdn.debugbear.com',
  DATA_URL: 'https://data.debugbear.com',
};
